import { CustomerType } from 'src/modules/userAccess/types/customer';

/**
 * Represents the type of a user in the user table.
 */
export type UserType = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  avatar: string;
  role_ids: number[];
  role_id: number;
  entity_name?: string;
  permissions: string[];
  status: UserStatusEnums;
  invite: Invite;
  user_deactivated_at?: string;
  access_rights: any;
  created_at: string;
  user_type?: RequestUserType;
  is_supplier: boolean;
  entity: string;
  supplier_access?: boolean;
  reclassification_access?: boolean;
};

export enum UserInviteEnums {
  SENT = 'SENT',
  NOT_SENT = 'NOT_SENT',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
}
export enum RequestUserType {
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  USER = 'USER',
}
export enum UserStatusEnums {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum RoleEnums {
  ADMIN = 'Admin',
  CREATOR = 'Creator',
  VIEWER = 'Viewer',
}

export const ROLE_IDS = {
  MERIDIA_ADMIN: 1,
  ADMIN: 2,
  CREATOR: 3,
  VIEWER: 4,
} as const;

export type InviteStatus =
  | 'ACCEPTED'
  | 'EXPIRED'
  | 'SENT'
  | 'NOT SENT'
  | 'NOT_SENT';

interface Invite {
  status: InviteStatus;
  accepted_at?: Date | null;
  created_at?: Date | null;
  expires_at?: Date | null;
  expired?: boolean;
}

export interface SupplierType {
  id: number;
  name: string;
  status?: 'ACTIVE' | 'DEACTIVATED';
  users_count?: number;
  updated_at?: Date;
  created_at?: Date;
  deactivated_at?: Date;
  access_rights?: any;
  company_name?: string | null;
  customer: CustomerType;
}
export interface EntityType {
  id: number;
  name: string;
  is_customer?: boolean;
}

/**
 * Represents a request to update a user.
 */
export type UpdateUserRequest = Partial<UserType> & {
  deactivation_reason?: string;
};

/**
 * Represents a request to create a user.
 */
export type CreateUserRequest = Omit<UserType, 'status'>;

export type EditSupplierRequest = {
  id?: number;
  name?: string;
  status?: UserStatusEnums;
  deactivation_reason?: string;
};

export type CountryCommodityPermissionType = {
  commodity: string[];
  country: string[];
  origin: string[];
};
export type SelectionsType = {
  [country: string]: {
    [commodity: string]: boolean;
  };
};

export type CreatorType = {
  id: number;
  first_name: string;
  last_name: string;
};
export type CreatorSupplier = {
  first_name: string;
  last_name: string;
  email: string;
};
export type SupplierCreatePayload = {
  name: string;
  creators: CreatorSupplier[];
  access_rights: any;
};

export type SupplierCreatorPayload = {
  supplier_id: number;
  creators: CreatorSupplier[];
};

export type ErrorKeys = 'email' | 'first_name' | 'last_name' | 'name';

export type SupplierFormType = {
  id?: number;
  name: string;
  creators: any;
  access_rights: any;
  reclassification_access?: boolean;
};
